import { faAsterisk } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { FC, memo } from 'react';
import { theme } from '../../../theme';
import { DivTitle } from './styles';

type TProps = {
  title: string;
  isRequired?: boolean;
};

const FnFieldTitle: FC<TProps> = ({ title = '', isRequired = false }) => {
  return (
    <DivTitle>
      {title}
      {isRequired && <FontAwesomeIcon icon={faAsterisk} size="xs" color={theme.colors.active} />}
    </DivTitle>
  );
};

export default memo(FnFieldTitle);
